'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, ChangeEvent } from 'react';
import { useTranslations } from '@material-bank/i18n';
import { Body, Button, Caption, H6, Input, Label } from '@material-bank/mb3-components';
import { BellIcon } from '@material-bank/mtag-icons';
type ComingSoonDrawerContentProps = {
  isOpen: boolean;
  close: () => void;
};
export function ComingSoonDrawerContent(t0) {
  const $ = _c(76);
  const {
    isOpen,
    close
  } = t0;
  const t = useTranslations("comingSoon");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (!isOpen) {
        setEmail("");
        setError("");
        setIsSuccess(false);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== email || $[4] !== t) {
    t3 = function submitHandler() {
      if (!isValidEmail(email)) {
        setError(t("invalidEmail"));
        return;
      }
      setError("");
      console.log("Coming soon notification email:", email);
      setIsSuccess(true);
    };
    $[3] = email;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const submitHandler = t3;
  let t4;
  if ($[6] !== error) {
    t4 = function changeHandler(event) {
      setEmail(event.target.value);
      if (error) {
        setError("");
      }
    };
    $[6] = error;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const changeHandler = t4;
  const showError = !!error;
  if (isSuccess) {
    let t5;
    if ($[8] !== t) {
      t5 = t("successTitle");
      $[8] = t;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t5) {
      t6 = <H6 weight="semibold">{t5}</H6>;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t) {
      t7 = t("successDescription");
      $[12] = t;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t7) {
      t8 = <Body variant="small" weight="regular" className="text-muted-foreground">{t7}</Body>;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== t6 || $[17] !== t8) {
      t9 = <div className="flex flex-col gap-2">{t6}{t8}</div>;
      $[16] = t6;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== t) {
      t10 = t("done");
      $[19] = t;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== close || $[22] !== t10) {
      t11 = <Button size="xl" className="w-full rounded-full" data-haptic="medium" onClick={close}>{t10}</Button>;
      $[21] = close;
      $[22] = t10;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== t11 || $[25] !== t9) {
      t12 = <div className="flex flex-col gap-6 px-6 pt-2 pb-8">{t9}{t11}</div>;
      $[24] = t11;
      $[25] = t9;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    return t12;
  }
  let t5;
  if ($[27] !== t) {
    t5 = t("title");
    $[27] = t;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  let t6;
  if ($[29] !== t5) {
    t6 = <H6 weight="semibold">{t5}</H6>;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t) {
    t7 = t("description");
    $[31] = t;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== t7) {
    t8 = <Body variant="small" weight="regular" className="text-muted-foreground">{t7}</Body>;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== t6 || $[36] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t6}{t8}</div>;
    $[35] = t6;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== t) {
    t10 = t("emailLabel");
    $[38] = t;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== t10) {
    t11 = <Label htmlFor="coming-soon-email">{t10}</Label>;
    $[40] = t10;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== t) {
    t12 = t("emailPlaceholder");
    $[42] = t;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  const t13 = showError ? "destructive" : "default";
  const t14 = showError ? "coming-soon-email-error" : undefined;
  let t15;
  if ($[44] !== changeHandler || $[45] !== email || $[46] !== showError || $[47] !== t12 || $[48] !== t13 || $[49] !== t14) {
    t15 = <Input id="coming-soon-email" type="email" placeholder={t12} value={email} variant={t13} aria-required={true} aria-invalid={showError} aria-describedby={t14} onChange={changeHandler} />;
    $[44] = changeHandler;
    $[45] = email;
    $[46] = showError;
    $[47] = t12;
    $[48] = t13;
    $[49] = t14;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== error || $[52] !== showError) {
    t16 = showError ? <Caption id="coming-soon-email-error" className="text-red-500">{error}</Caption> : null;
    $[51] = error;
    $[52] = showError;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] !== t11 || $[55] !== t15 || $[56] !== t16) {
    t17 = <div className="flex flex-col gap-1.5">{t11}{t15}{t16}</div>;
    $[54] = t11;
    $[55] = t15;
    $[56] = t16;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  let t18;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <BellIcon size={18} />;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  let t19;
  if ($[59] !== t) {
    t19 = t("notifyMe");
    $[59] = t;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== submitHandler || $[62] !== t19) {
    t20 = <Button size="xl" className="w-full rounded-full" data-haptic="medium" onClick={submitHandler}>{t18}{t19}</Button>;
    $[61] = submitHandler;
    $[62] = t19;
    $[63] = t20;
  } else {
    t20 = $[63];
  }
  let t21;
  if ($[64] !== t) {
    t21 = t("noThanks");
    $[64] = t;
    $[65] = t21;
  } else {
    t21 = $[65];
  }
  let t22;
  if ($[66] !== close || $[67] !== t21) {
    t22 = <Button variant="outline" size="xl" className="w-full rounded-full" data-haptic="light" onClick={close}>{t21}</Button>;
    $[66] = close;
    $[67] = t21;
    $[68] = t22;
  } else {
    t22 = $[68];
  }
  let t23;
  if ($[69] !== t20 || $[70] !== t22) {
    t23 = <div className="flex flex-col gap-2">{t20}{t22}</div>;
    $[69] = t20;
    $[70] = t22;
    $[71] = t23;
  } else {
    t23 = $[71];
  }
  let t24;
  if ($[72] !== t17 || $[73] !== t23 || $[74] !== t9) {
    t24 = <div className="flex flex-col gap-6 px-6 pt-2 pb-8">{t9}{t17}{t23}</div>;
    $[72] = t17;
    $[73] = t23;
    $[74] = t9;
    $[75] = t24;
  } else {
    t24 = $[75];
  }
  return t24;
}

//////
function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}